import { createFileRoute } from "@tanstack/react-router";
import ShowroomSandbox from "lib/components/showroom2/pages/ShowroomSandbox";
import { ShowroomProvider } from "lib/components/showroom2/state/useShowroomState";
import { useAppRouterParams } from "lib/routeHelpers";

function ShowroomSandboxPage() {
  const { builderId, id } = useAppRouterParams();
  const showroomKey = [builderId, id].filter(Boolean).join("-") || undefined;

  return (
    <ShowroomProvider key={showroomKey}>
      <ShowroomSandbox />
    </ShowroomProvider>
  );
}

export const Route = createFileRoute("/demo/showroom")({
  component: ShowroomSandboxPage,
  staticData: { isPublicPage: true },
});
